import React from 'react';
export const ConfigurationContext = React.createContext({
    configuration: null,
    loading: false,
    error: false
});
export const useConfigurationContext = () => React.useContext(ConfigurationContext);
